/* eslint-disable */
// import { type } from '@testing-library/user-event/dist/type';
import {  HANDLE_API_CREATE_COMBO } from './constants';

export function getDataFromAPICreateCombo(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 


{
  console.log("khan getDataFromAPICreateCombo ACTION ")
  
  return {
    type: HANDLE_API_CREATE_COMBO,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}







